module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAAAXNSR0IArs4c6QAAAT1JREFUOE+1kDFKA1EURc/NSBZg4wLSiJDCHfxKS7EIKd2CWAmGKNjYugPBRqysFCKYDAkEESSiIsRWEAxoYSEDk3kyMoE4OkOI+Kp/ee8f7r0CcM5tAlvxO2PegyAodbvdj6wDJaATYCUHRBiGs51O5+3PoGKxONdoNF4mBcXW78eOPWAx0Qb0gVugJ6kXhuF1u91+jvffopnZse/71RGoUql4g8EgzItsZnXf93fTHQXAQ8pROQ8kqdFsNpcnLjsHdt5qtZbS0U4lrY19mgG+OkjGHw6HFc/zzMzKki6AnyDgCThKgdZH2sxegQNJEVACVrNAeXVk7X51dAPspRwdjunHKIp2CoVC7Gge2M5ydAnUUqCzMX1nZhuS4o4WJO3/e7TpO3LOVSXVY6vTUIBHSTU5566S4qbkgKT+J88EmLrRD8NUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/loupanshuju.png
// module id = Ef8S
// module chunks = 1